<div class="lm-report-personalization" soho-busyindicator [text]="' '" [displayDelay]="20" [overlayOnly]="true">
    <div *ngIf="true then CONTEXT_FORM"></div>
    <div soho-tabs>
      <div soho-tab-list-container>
        <ul soho-tab-list>
          <ng-container *ngIf="!isCubeView">
            <li soho-tab [disabled]="disableTabs">
              <a soho-tab-title tabId="tabs-normal-column">{{ 'ListPersonalizationColumnTab' | translate }}</a>
            </li>
            <li *ngIf="!isPrimaryList || this.mode === 'createReport' || this.mode === 'report'" soho-tab [disabled]="disableTabs"><a soho-tab-title
                tabId="tabs-normal-filter">{{ 'ListPersonalizationFilterTab' | translate }}</a></li>
            <li soho-tab [disabled]="disableTabs">
              <a soho-tab-title tabId="tabs-normal-display">{{ 'ListPersonalizationDisplayTab' | translate }}</a>
            </li>
            <li *ngIf="this.mode === 'createReport' || this.mode === 'report'" soho-tab [disabled]="disableTabs"><a soho-tab-title
                tabId="tabs-normal-datasource">{{ 'ListPersonalizationDataSourceTab' | translate }}</a></li>
          </ng-container>
          <ng-container *ngIf="isCubeView">
            <li soho-tab>
              <a soho-tab-title tabId="tabs-normal-dimensions">{{ 'Dimensions' | translate }}</a>
            </li>
            <li soho-tab>
              <a soho-tab-title tabId="tabs-normal-column">{{ 'Measures' | translate }}</a>
            </li>
            <li soho-tab>
              <a soho-tab-title tabId="tabs-normal-display">{{ 'ListPersonalizationDisplayTab' | translate }}</a>
            </li>
          </ng-container>
        </ul>
      </div>
      <div soho-tab-panel-container>
        <ng-container *ngIf="!isCubeView">
          <div *ngIf="true then COLUMNS_TAB_CONTENT"></div>
          <div *ngIf="!isPrimaryList || this.mode === 'report' || this.mode === 'createReport' then FILTER_TAB_CONTENT"></div>
          <div *ngIf="true then DISPLAY_TAB_CONTENT"></div>
          <div *ngIf="true then DATA_SOURCE_TAB_CONTENT"></div>
        </ng-container>
        <ng-container *ngIf="isCubeView">
          <div *ngIf="true then DIMENSIONS_TAB_CONTENT"></div>
          <div *ngIf="true then COLUMNS_TAB_CONTENT"></div>
          <div *ngIf="true then DISPLAY_TAB_CONTENT"></div>
        </ng-container>
      </div>
    </div>
<!--  </div>-->

  <!--TEMPLATE SUB PARTS-->
  <ng-template #CONTEXT_FORM>
    <div class="row titleSharing-fields-container">
      <div class="four columns">
        <div class="field">
          <label *ngIf="this.mode !== 'report'" soho-label class="required" for="reportName">{{ 'ListPersonalizationListTitleLabel' | translate }}</label>
          <label *ngIf="this.mode === 'report'" soho-label class="required" for="reportName">{{ 'ListPersonalizationReportNameLabel' | translate }}</label>
          <input
                  soho-input
                  name="reportName"
                  id="reportName"
                  data-automation-id="lm-personalization-report-name"
                  spellcheck="false"
                  soho-trackdirty
                  data-validate="required"
                  (dirty)="onTitleDirty($event)"
                  (afterResetDirty)="onTitleAfterResetDirty($event)"
                  (pristine)="onTitlePristine($event)"
                  [(ngModel)]="model.name">
        </div>
      </div>
    </div>
    <div *ngIf="this.mode === 'report'" class="row reportMode-fields-container">
      <div class="four columns">
        <div class="field">
          <label soho-label [required]="true" for="businessClass">{{ 'CreateReportBusinessClassLabel' | translate }}</label>
          <select soho-dropdown id="businessClass"
            name="businessClass"
            data-automation-id="lm-personalization-business-class"
            [source]="businessClassSource"
            (change)="onBCChange($event)"
            [(ngModel)]="model.businessClass"
            soho-trackdirty
            soho-alert
            data-validate="required"
          >
            <option *ngFor="let businessClass of businessClasses" [value]="businessClass.value">{{businessClass.label}}</option>
          </select>
        </div>
      </div>
      <div class="four columns">
        <div *ngIf="model.businessClass" class="field">
          <label soho-label [required]="true"for="listName">{{ 'CreateReportListLabel' | translate }}</label>
          <select soho-dropdown
            id="listName"
            name="listName"
            data-automation-id="lm-personalization-list-name"
            [source]="listNameSource"
            (change)="onListChange($event)"
            [(ngModel)]="model.listName"
            soho-trackdirty
          >
            <option *ngFor="let listName of listNames" [value]="listName.value">{{listName.label}}</option>
          </select>
        </div>
      </div>
    </div>
<!--    <div *ngIf="this.mode === 'report' && noChartView" class="row" style="margin-bottom: 20px;margin-left: 0px;">-->
<!--      <div class="eight columns" style="margin-left: 0px; text-align: left;">-->
<!--        <label>{{ 'CreateReportNoPredefinedChartsMessage' | translate }}</label>-->
<!--      </div>-->
<!--    </div> -->
    <div *ngIf="allowSharing" class="row titleSharing-fields-container">
      <div class="four columns">
        <div class="field">
          <label soho-label for="sharing">{{ 'CreateReportSharing' | translate }}</label>
          <select soho-dropdown
            id="sharing" noSearch
            name="sharing"
            data-automation-id="lm-personalization-sharing"
            [source]="sharingSource"
            (change)="onSharingChange($event)"
            soho-trackdirty
            [(ngModel)]="model.sharing">
            <option *ngFor="let share of sharing" [value]="share.value">{{share.label}}</option>
          </select>
        </div>
      </div>
      <div class="four columns">
        <div *ngIf="actorGroupSharing" class="field">
          <label soho-label class="required">{{ 'CreateReportActorGroupLabel' | translate }}</label>
          <input
            data-automation-id="lm-personalization-actor-group"
            soho-lookup
            [click]="onLookupClick"
            [field]="onLookupField"
            soho-trackdirty
            soho-busyindicator blockUI="true" displayDelay="0"
            id="{{testVersion3 ? 'report-personalization-actorGroup' : 'actorGroup'}}"
            [(ngModel)]="model.actorGroup"
          />
        </div>
        <div *ngIf="roleSharing" class="field">
          <label soho-label class="required">{{ 'CreateReportRoleLabel' | translate }}</label>
          <input
            data-automation-id="lm-personalization-role"
            soho-lookup
            [click]="onLookupClick"
            [field]="onLookupField"
            soho-trackdirty
            soho-busyindicator blockUI="true" displayDelay="0"
            id='report-personalization-role'
            [(ngModel)]="model.role"
          />
        </div>
        <div *ngIf="roleGroupSharing" class="field">
          <label soho-label class="required">{{ 'CreateReportRoleGroupLabel' | translate }}</label>
          <input
            data-automation-id="lm-personalization-role-group"
            soho-lookup
            [click]="onLookupClick"
            [field]="onLookupField"
            soho-trackdirty
            soho-busyindicator blockUI="true" displayDelay="0"
            id='report-personalization-roleGroup'
            [(ngModel)]="model.roleGroup"
          />
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #COLUMNS_TAB_CONTENT>
    <div soho-tab-panel tabId="tabs-normal-column">
      <div class="row">
        <div class="four columns">
          <soho-toolbar-flex noActionsButton=true hasMoreButton=false>
            <soho-toolbar-title></soho-toolbar-title>
            <soho-toolbar-flex-section>
              <button
                      data-automation-id="lm-personalization-add-item-btn"
                      type="button"
                      id="add-item"
                      soho-menu-button
                      icon="add"
                      menu="addColumnMenu" [disabled]="disableTabs">{{ 'Add' | translate}}</button>
              <ul soho-popupmenu id="addColumnMenu">
                <li soho-popupmenu-item>
                  <a soho-popupmenu-label (click)="onAddField()">{{ 'ListPersonalizationAddFieldButtonLabel40' | translate }}</a>
                </li>
                <li *ngIf="!isColumnarView && !isCubeView" soho-popupmenu-item>
                  <a soho-popupmenu-label (click)="onAddCompute()">{{ 'ListPersonalizationAddComputeButtonLabel40' | translate }}</a>
                </li>
              </ul>
              <button type="button" id="show-label" soho-menu-button menu="showLabelMenu" [disabled]="disableTabs">{{showLabelText}}</button>
              <ul soho-popupmenu id="showLabelMenu">
                <li soho-popupmenu-item><a soho-popupmenu-label (click)="onShowLabel(true)">{{ 'ShowLabel' | translate }}</a></li>
                <li soho-popupmenu-item><a soho-popupmenu-label (click)="onShowLabel(false)">{{ 'ShowField' | translate }}</a></li>
              </ul>
              <button
                data-automation-id="lm-personalization-delete-item-btn"
                id="delete-item"
                [disabled]="disableRemove"
                soho-button="icon"
                icon="delete" (click)="onRemoveField()" [disabled]="disableTabs">{{ 'ListPersonalizationRemoveButtonLabel' | translate }}</button>
            </soho-toolbar-flex-section>
          </soho-toolbar-flex>
          <div class="scrollable-flex-content" style="margin-top: 5px;"
              *ngIf="columnGridOptions"
              data-automation-id="lm-personalization-field-data-grid"
              soho-datagrid  #columnDataGridComponent
              [attr.id]="columnDataGridComponent"
              [gridOptions]="this.columnGridOptions"
              (rowClicked)="onRowClicked($event)">
          </div>
        </div>
        <div *ngIf="selectedField" class="eight columns detail-column">
          <ng-container *ngIf="!selectedField.compute">
              <span id="detailHeader" class="">{{ 'Details' | translate }}</span>
              <div class="personalization-pane-div details">
                <div class="row top-padding">
                  <div class="eight columns">
                    <div class="field">
                      <label soho-label class="required" for="name">{{ 'ColumnEditorFieldLabel' | translate}}</label>
                      <input
                        data-automation-id="lm-personalization-field-name"
                        type="text" name="fieldName" id="name" #fieldName
                        style="width:100%"
                        soho-autocomplete
                          [source]="autoCompleteSource"
                          [filterMode]="null"
                          [delay]="400"
                          (selected)="onAutoCompleteSelected($event)"
                          (change)="onChange(true)"
                          (focusout)="validateField()"
                        soho-alert attr.data-validate="required"
                        soho-trackdirty
                        [(ngModel)]="selectedField.name"
                        soho-busyindicator
                        [blockUI]="false"
                        [displayDelay]="500"
                        >
                    </div>
                  </div>
                  <div  class="four columns">
                    <div class="field">
                      <label class="label place-holder" style="visibility: hidden" aria-hidden="true"></label>
                      <button *ngIf="selectedField.type === 'Field'" data-automation-id="field-picker-advanced-search" soho-button="primary" (click)="onGetFieldQualifier($event)" title="{{ 'AdvancedSearchLabel' | translate }}">{{ 'AdvancedSearchLabel' | translate }}</button>
                    </div>
                  </div>
                </div>
                <div *ngIf="selectedField.type === 'Field'" class="row label-field-container">
                  <div class="field eight columns">
                    <label soho-label for="label">{{ 'ColumnEditorLabelLabel' | translate}}</label>
                    <input
                            data-automation-id="lm-personalization-field-label"
                            type="text" name="label" #columnlabel id="label" soho-trackdirty [(ngModel)]="selectedField.placeholder" (dirty)="onLabelDirty()" (pristine)="onLabelDirty()">
                  </div>
                  <div  class="four columns"></div>
                </div>
                <div class="row">
                  <div class="eight columns">
                    <ng-container *ngIf="!isColumnarView && selectedField.type === 'Field'">
                      <div class="field top-margin">
                        <input #allowUpdateOption
                               data-automation-id="lm-personalization-field-allow-update"
                               soho-checkbox type="checkbox" class="checkbox" id="allowUpdate"
                               soho-trackdirty [(ngModel)]="selectedField.allowUpdate" [disabled]="!selectedField.canUpdate" (change)="onChange()">
                        <label soho-label for="allowUpdate" [forCheckBox]="true">{{ 'ListPersonalizationAllowUpdate' | translate }}</label>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            <soho-accordion class="" [allowOnePane]="false">
              <soho-accordion-header id="alertsHeader"  class="" [ngClass]="{ 'hidden' : selectedField.type !== 'Field' || isCubeView }">{{ 'FieldEditorAlertsTab' | translate }}</soho-accordion-header>
              <soho-accordion-pane class="personalization-pane-div" [ngClass]="{ 'hidden' : selectedField.type !== 'Field' || isCubeView }">
                <div class="scrollable-flex">
                  <soho-toolbar-flex noActionsButton=true hasMoreButton=false>
                    <soho-toolbar-title></soho-toolbar-title>
                    <soho-toolbar-flex-section>
                      <!--                        <button id="add-item" soho-button="icon" icon="add" (click)="onAddAlert()">Add</button>-->
                      <button
                              data-automation-id="lm-personalization-add-alert-btn"
                              soho-menu-button icon="add" menu="addAlertMenu" [disabled]="hasAllAlerts" type="button" id="add-Alert"></button>
                      <ul soho-popupmenu id="addAlertMenu">
                        <li *ngIf="noRedAlert" soho-popupmenu-item><a soho-popupmenu-label (click)="onAddAlert(1)">{{ 'FieldEditorAddRedAlert' | translate }}</a></li>
                        <li *ngIf="noYellowAlert" soho-popupmenu-item><a soho-popupmenu-label (click)="onAddAlert(2)">{{ 'FieldEditorAddYellowAlert' | translate }}</a></li>
                        <li *ngIf="noGreenAlert" soho-popupmenu-item><a soho-popupmenu-label (click)="onAddAlert(3)">{{ 'FieldEditorAddGreenAlert' | translate }}</a></li>
                        <li *ngIf="noBlueAlert" soho-popupmenu-item><a soho-popupmenu-label (click)="onAddAlert(4)">{{ 'FieldEditorAddBlueAlert' | translate }}</a></li>
                      </ul>
                      <button
                              data-automation-id="lm-personalization-delete-alert-btn"
                              id="delete-alert" soho-button="icon" icon="delete" (click)="onDeleteAlert()">Delete</button>
                    </soho-toolbar-flex-section>
                  </soho-toolbar-flex>
                  <div class="alerts-data-grid"
                      data-automation-id="lm-personalization-alert-data-grid"
                      *ngIf="alertGridOptions"
                      soho-datagrid #alertDataGridComponent
                      [attr.id]="alertDataGridComponent"
                      [gridOptions]="this.alertGridOptions"
                      (rowClicked)="onAlertRowClicked($event)"
                      (rowAdd)="onAlertRowAdd($event)"
                      (rowRemove)="onAlertRowRemove($event)"
                      (cellchange)="onCellChange($event)"></div>
                </div>
              </soho-accordion-pane>
              <soho-accordion-header id="sortTotalHeader" class=""  [ngClass]="{ 'hidden' : selectedField.type !== 'Field' || isCubeView}" >{{ 'FieldEditorTotalSortTab' | translate }}</soho-accordion-header>
              <soho-accordion-pane class="personalization-pane-div" [ngClass]="{ 'hidden' : selectedField.type !== 'Field' || isCubeView }">
                <div class="row top-padding">
                    <div *ngIf="!isColumnarView" class="field six columns">
                        <div *ngIf="selectedField.sortOrder" class="row">
                          <div class="four columns">
                            <div class="field top-margin">
                              <input
                                data-automation-id="lm-personalization-field-default-sort"
                                soho-checkbox 
                                type="checkbox" 
                                id="defaultSortColumn" 
                                name="defaultSortColumn" 
                                soho-trackdirty 
                                [disabled]="!this.selectedField.sortOrder"
                                [(ngModel)]="selectedField.defaultSort" 
                                (change)="onSortChange()">
                              <label soho-label [forCheckBox]="true" for="defaultSortColumn">{{ 'ListPersonalizationDefaultSortLabel40' | translate }}</label>
                            </div>
                          </div>
                          <div class="four columns">
                            <div class="field top-margin">
                              <input
                                data-automation-id="lm-personalization-field-sort-descending"
                                soho-checkbox 
                                [disabled]="!selectedField.defaultSort" 
                                type="checkbox" 
                                id="sortDescending" 
                                name="sortDescending" 
                                soho-trackdirty
                                [(ngModel)]="selectedField.sortDescending" 
                                (change)="onSortDescendingChange()">
                              <label soho-label [forCheckBox]="true" for="sortDescending">{{ 'ListPersonalizationSortDescendingLabel40' | translate }}</label>
                            </div>
                          </div>
                        </div>
                        <label soho-label for="sortOrder">{{ 'ColumnEditorSortOrderLabel' | translate }}</label>
                        <select #sortOrder
                          data-automation-id="lm-personalization-field-sort-order"
                          soho-dropdown 
                          noSearch 
                          id="sortOrder" 
                          name="sortOrder"
                          soho-trackdirty 
                          (ngModelChange)="onSortOrderChanged($event)" 
                          [(ngModel)]="selectedField.sortOrder">
                          <option *ngFor="let sort of sortOrders" [value]="sort.value">{{sort.label}}</option>
                        </select>
                        <ng-container *ngIf="selectedField.sortOrderFields && selectedField.sortOrderFields.length > 0">
                          <div id="sortOrderField" name="sortOrderField" class="fieldset">
                            <div class="summary-form">
                              <label style="font-weight:bold">{{ 'Fields' | translate }}</label>
                              <div *ngFor="let sortField of selectedField.sortOrderFields">
                                <label soho-label [style.text-indent]="sortField.sortBreak ? '0px' : '8px'">{{sortField.name}}</label>
                              </div>
                              <div *ngIf="selectedField.sortOrderFields && selectedField.sortOrderFields.length > 0">
                                <br>
                                <label>{{ 'ColumnEditorSubTotalBreakPointMessage' | translate }}</label>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                    </div>
                    <div class="field six columns">
                      <label soho-label [attr.for]="selectedField.totaling">{{ 'ColumnEditorColumnTotalingLabel' | translate }}</label>
                      <select
                        data-automation-id="lm-personalization-field-totaling"
                        soho-dropdown 
                        noSearch 
                        id="totaling" 
                        name="totaling" 
                        [source]="totalSource"
                        soho-trackdirty 
                        [(ngModel)]="selectedField.totaling" 
                        (change)="onChange()">
                        <option *ngFor="let total of totaling" [value]="total.value">{{total.label}}</option>
                      </select>
                    </div>
                </div>
              </soho-accordion-pane>
            </soho-accordion>
          </ng-container>
          <ng-container *ngIf="selectedField.compute">
            <div class="row top-padding">
              <div class="eleven columns">
                <div class="field">
                  <label soho-label for="computeLabel">{{ 'ColumnEditorLabelLabel' | translate}}</label>
                  <input
                    data-automation-id="lm-personalization-compute-label"
                    type="text" 
                    name="computeLabel" 
                    id="computeLabel" 
                    soho-trackdirty 
                    (dirty)="onLabelDirty()"
                    (pristine)="onLabelDirty()"
                    [(ngModel)]="selectedField.placeholder">
                </div>
              </div>
            </div>
            <div class="row">
              <div class="field nine columns">
                <textarea
                  data-automation-id="lm-personalization-compute-lpl"
                  soho-alert
                  soho-textarea 
                  id="compute" 
                  name="compute" 
                  attr.data-validate="{{isRequired('compute')}}" 
                  (change)="onChange()" 
                  soho-trackdirty [(ngModel)]="selectedField.name">
                </textarea>
              </div>
              <div class="field two columns">
                <button
                        data-automation-id="lm-personalization-compute-builder-btn"
                        soho-button="primary"
                        (click)="onBuildComputeCondition()"
                        title="{{'BuilderNoEllipses' | translate }}"
                >{{ 'BuilderNoEllipses' | translate}}</button>
              </div>
            </div>
            <div class="row">
              <div class="field four columns">
                <label soho-label [attr.for]="selectedField.totaling">{{ 'ColumnEditorColumnTotalingLabel' | translate }}</label>
                <select
                    data-automation-id="lm-personalization-compute-totaling"
                    soho-dropdown 
                    noSearch 
                    id="computeTotaling" 
                    name="computeTotaling" 
                    [source]="totalSource"
                    soho-trackdirty 
                    [(ngModel)]="selectedField.totaling" 
                    (change)="onChange()">
                  <option *ngFor="let total of totaling" [value]="total.value">{{total.label}}</option>
                </select>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #FILTER_TAB_CONTENT>
    <div soho-tab-panel tabId="tabs-normal-filter">
      <div class="row top-padding">
        <div class="field eleven columns">
          <label>{{ 'ListPersonalizationFilterLabel' | translate }}</label>
        </div>
      </div>
      <div class="row">
        <div class="field eight columns">
          <textarea #filterCondition
              [attr.id]="'filterCriteria'"
              data-automation-id="lm-personalization-filter-criteria"
              name="filterCriteria"
              spellcheck="false"
              soho-textarea
              soho-alert
              [id]="'lm-personalization-instance-selection-alert'"
              soho-trackdirty
              [(ngModel)]="model.conditionString"
              (ngModelChange)="instanceSelectionValidator$.next($event)">
          </textarea>
        </div>
        <div class="field two columns">
          <button
              data-automation-id="lm-personalization-filter-criteria-builder-btn"
              soho-button="primary"
              (click)="onBuildButtonEvent($event)"
          >{{ 'BuilderNoEllipses' | translate}}</button>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #DISPLAY_TAB_CONTENT>
    <div soho-tab-panel tabId="tabs-normal-display">
      <div class="row top-padding">
        <h2 class="fieldset-title">{{ 'PrintToFile' | translate }}</h2>
        <div class="field">
          <label soho-label for="fontOffset">{{ 'PDFFontSizeOffsetReport' | translate }}</label>
          <input
            data-automation-id="lm-personalization-pdf-offset"
            soho-spinbox name="fontOffset" id="fontOffset" min="-5" max="20" [(ngModel)]="model.fontOffset" soho-trackdirty />
        </div>
        <div class="field field-radio">
          <label for="name">{{'PDFOrientation' | translate}}</label>
          <input
            data-automation-id="lm-personalization-pdf-landscape-orientation"
            type="radio" class="radio" id="landscape" value="landscape" [(ngModel)]="model.orientation" soho-trackdirty />
          <label for="landscape" class="radio-label">{{'PDFOrientationLandscape' | translate}}</label>
          <input
            data-automation-id="lm-personalization-pdf-portrait-orientation"
            type="radio" class="radio" id="portrait" value="portrait" [(ngModel)]="model.orientation" soho-trackdirty />
          <label for="portrait" class="radio-label">{{'PDFOrientationPortrait' | translate}}</label>
        </div>
      </div>
      <div class="row top-padding" *ngIf="!noChartView">
        <h2 class="fieldset-title">{{'CreateReportDefViewLabel' | translate}}</h2>
        <div class="field">
          <select soho-dropdown
                  id="viewName"
                  name="viewName"
                  data-automation-id="lm-personalization-view-name"
                  [source]="viewNameSource"
                  [(ngModel)]="model.viewName"
                  soho-trackdirty
          >
            <option *ngFor="let viewName of viewNames" [value]="viewName.value">{{viewName.label}}</option>
          </select>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #DATA_SOURCE_TAB_CONTENT>
    <div soho-tab-panel tabId="tabs-normal-datasource">
      <div class="row top-padding">
        <div class="field">
          <input
            data-automation-id="lm-personalization-audit-data-source"
            soho-radiobutton 
            type="radio" 
            soho-trackdirty 
            name="optionsGroupData" 
            id="optionsGroupDataAudit"
            value="audit" 
            [(ngModel)]="model.dataOption" 
            (change)="onAudiDataOptionChanged()"/>
          <label soho-label for="optionsGroupDataAudit">{{ 'CreateReportMatchAudit' | translate }}</label>
          <input
            data-automation-id="lm-personalization-live-data-source"
            soho-radiobutton 
            type="radio" 
            soho-trackdirty 
            name="optionsGroupData" 
            id="optionsGroupDataLive"
            value="live" 
            [(ngModel)]="model.dataOption" 
            (change)="onAudiDataOptionChanged()"/>
          <label soho-label for="optionsGroupDataLive">{{ 'CreateReportMatchLive' | translate }}</label>
        </div>
      </div>
      <div class="row">
        <div class="field lm-is-indent">
          <label soho-label>{{ 'CreateReportAsOfDateLabel' | translate }}</label>
          <input
            data-automation-id="lm-personalization-as-of-date"
            soho-datepicker 
            [options]="pickerOptions" 
            [disabled]="disableAsOfDate" 
            soho-trackdirty
            [(ngModel)]="model.asOfDate"/>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #DIMENSIONS_TAB_CONTENT>
    <div class="row top-padding" soho-tab-panel tabId="tabs-normal-dimensions">
      <lm-cube-dimensions-dialog [listSpec]="listSpec" [dataViewSet]="dataViewSet" [listState]="cubeViewState" [parentContainer]="cubeParent"></lm-cube-dimensions-dialog>
    </div>
  </ng-template>
</div>
